import { render, staticRenderFns } from "./SubmitTestNotMember.vue?vue&type=template&id=2070314e&scoped=true&v-slot%3Acontent=true&"
import script from "./SubmitTestNotMember.vue?vue&type=script&lang=ts&"
export * from "./SubmitTestNotMember.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitTestNotMember.vue?vue&type=style&index=0&id=2070314e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070314e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
